"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLargestEligibleUnitTypeForIncomeAndSize = exports.getLargestEligibleUnitType = exports.unitTypeToTextSingular = exports.unitTypeToText = exports.getUnitTypeEligibility = exports.getRelevantApartmentsForIncomeAndSize = void 0;
exports.getFullAddress = getFullAddress;
const priorities = {
    'senior-ineligible': 0,
    'income-too-low': 1,
    'income-too-high': 2,
    'household-size-too-low': 3,
    'household-size-too-high': 4,
};
const getRelevantApartmentsForIncomeAndSize = (unitTypes, data) => {
    const eligibleForSenior = data.eligibleForSenior;
    const unitTypesWithEligibility = unitTypes.map(unitType => ({
        unitType: unitType,
        eligibility: (0, exports.getUnitTypeEligibility)(unitType, data, eligibleForSenior)
    }));
    const eligibleUnitTypes = unitTypesWithEligibility.filter(unitType => unitType.eligibility.status === 'eligible');
    if (eligibleUnitTypes.length > 0) {
        return { status: 'eligible', advertisements: eligibleUnitTypes.map(unitType => unitType.unitType) };
    }
    const reason = unitTypesWithEligibility
        .map(unitType => unitType.eligibility)
        .filter(eligibility => eligibility.status === 'ineligible')
        .map(eligibility => eligibility.reason)
        .sort((a, b) => {
        return priorities[b] - priorities[a];
    }).pop();
    return { status: 'ineligible', reason: reason ?? 'income-too-high' };
};
exports.getRelevantApartmentsForIncomeAndSize = getRelevantApartmentsForIncomeAndSize;
const getUnitTypeEligibility = (unitAdvertisement, data, eligibleForSenior) => {
    if (unitAdvertisement.type === 'senior' && !eligibleForSenior) {
        return { status: 'ineligible', reason: 'senior-ineligible' };
    }
    if (data.size > unitAdvertisement.householdSize) {
        return { status: 'ineligible', reason: 'household-size-too-high' };
    }
    if (data.size < unitAdvertisement.householdSize) {
        return { status: 'ineligible', reason: 'household-size-too-low' };
    }
    if (data.lowerHouseholdIncome > unitAdvertisement.maxIncome) {
        return { status: 'ineligible', reason: 'income-too-high' };
    }
    if (data.upperHouseholdIncome < unitAdvertisement.minIncome) {
        if (data.receivesRentalAssistance) {
            // Rental assistance only offsets being under the minimum income threshold.
            return { status: 'eligible' };
        }
        return { status: 'ineligible', reason: 'income-too-low' };
    }
    return { status: 'eligible' };
};
exports.getUnitTypeEligibility = getUnitTypeEligibility;
const unitTypePriority = {
    'studio': 0,
    'one-bedroom': 1,
    'two-bedrooms': 2,
    'three-bedrooms': 3,
    'four-bedrooms': 4,
    'five-bedrooms': 5,
    'six-bedrooms': 6,
};
const unitTypeToText = (unitType) => {
    switch (unitType) {
        case 'studio':
            return 'Studio';
        case 'one-bedroom':
            return '1 Bedroom';
        case 'two-bedrooms':
            return '2 Bedrooms';
        case 'three-bedrooms':
            return '3 Bedrooms';
        case 'four-bedrooms':
            return '4 Bedrooms';
        case 'five-bedrooms':
            return '5 Bedrooms';
        case 'six-bedrooms':
            return '6 Bedrooms';
    }
};
exports.unitTypeToText = unitTypeToText;
const unitTypeToTextSingular = (unitType) => {
    switch (unitType) {
        case 'studio':
            return 'Studio';
        case 'one-bedroom':
            return '1 Bedroom';
        case 'two-bedrooms':
            return '2 Bedroom';
        case 'three-bedrooms':
            return '3 Bedroom';
        case 'four-bedrooms':
            return '4 Bedroom';
        case 'five-bedrooms':
            return '5 Bedroom';
        case 'six-bedrooms':
            return '6 Bedroom';
    }
};
exports.unitTypeToTextSingular = unitTypeToTextSingular;
const getLargestEligibleUnitType = (advertisements) => {
    if (advertisements.length === 0) {
        return undefined;
    }
    return advertisements
        .map(ad => ad.unitType)
        .sort((a, b) => unitTypePriority[b] - unitTypePriority[a])[0];
};
exports.getLargestEligibleUnitType = getLargestEligibleUnitType;
const getLargestEligibleUnitTypeForIncomeAndSize = (unitAdvertisements, data) => {
    if (!unitAdvertisements) {
        return { eligible: false };
    }
    const eligibility = (0, exports.getRelevantApartmentsForIncomeAndSize)(unitAdvertisements, data);
    if (eligibility.status !== 'eligible' || eligibility.advertisements.length === 0) {
        return { eligible: false };
    }
    const unitType = (0, exports.getLargestEligibleUnitType)(eligibility.advertisements);
    if (!unitType) {
        return { eligible: false };
    }
    return { eligible: true, unitType };
};
exports.getLargestEligibleUnitTypeForIncomeAndSize = getLargestEligibleUnitTypeForIncomeAndSize;
function getFullAddress(addressInfo) {
    return `${addressInfo.address}, ${addressInfo.city}, ${addressInfo.state} ${addressInfo.zip}`;
}
